module.exports = __webpack_public_path__ + "static/media/succeed3.d0e644f8.jpg";